import "../phaser.min.js";
import Common from "../Includes/Common.js";
class Car extends Phaser.Scene {
    constructor() {
        super('Car');
        this.common = new Common();
    }

    init(data) {
        this.x = data.x;
        this.y = this.scale.height / 12 * 5.9;
        this.carKey = data.carKey;
        this.driving = data.driving;
    }

    preload() {
        this.load.atlas('emotes', this.common.assetsPath + 'sprites/emotes.png', this.common.assetsPath + 'sprites/emotes_atlas.json');
    }

    create() {
        const atlasKey = this.carKey + '-atlas';
        const animationKey = this.carKey + '-driving2';
        if(this.anims.exists(animationKey)) this.anims.remove(animationKey)
        this.anims.create({
            key: animationKey,
            frames: this.anims.generateFrameNames(atlasKey, {
                prefix: this.carKey + ' ',
                start: 0,
                end: 4,
                zeroPad: 0,
                suffix: '.aseprite'
            }),
            frameRate: 20,
            repeat: -1
        })

        this.lights.enable();
        this.light = this.lights.addLight(this.x, this.y,  3000, 0xffffff, 1);
        const carY = this.scale.height / 12 * 5.75;
        this.car = this.add.sprite(0,0, atlasKey, 0).setOrigin(0.5, 1).setScale(4).setLighting(true);
        this.carContainer = this.add.container(this.x, this.y, [this.car]);







        this.events.on('play-car-driving', () => {
            if(this.car.anims.currentAnim.key === animationKey) return;
            this.car.play(animationKey);
        })

        if(this.driving) {
            this.car.play(animationKey);
        }

        let quiz = this.scene.get('Quiz');
        this.onScrollSpeedChanged = (data) => {
            if(data.scrollSpeed >= 0 && Math.floor(data.scrollSpeed) === 0 && this.car.anims.currentAnim && this.car.anims.currentAnim.key === animationKey) {
                this.car.anims.stop();
                this.car.setFrame(0);
            }else{
                this.car.play(animationKey);
            }
        };
        quiz.events.on('scroll-speed-changed', this.onScrollSpeedChanged, this)


        this.onStreakTriggered = () => {
            const startingY = this.carContainer.y;
            this.showEmote('fire-emote')
            this.tweens.add({
                targets: this.carContainer,
                y: this.carContainer.y - 10 * 4,
                duration: 120,
                ease: 'Linear',
                yoyo: true,
                repeat: 1,
                onComplete: () => {
                    this.carContainer.y = startingY;
                }
            })
        };
        quiz.events.on('streak-triggered', this.onStreakTriggered, this)

        quiz.events.on('streak-ended', (data) => {
            if(data.errorThreshold - 2 === data.wrongAnswers) {
                this.showEmote('frown-emote')
            }else {
                this.showEmote('bruh-emote')
            }
        }, this)

        this.events.once('shutdown', () => {
            quiz.events.off('scroll-speed-changed', this.onScrollSpeedChanged, this);
            quiz.events.off('streak-triggered', this.onStreakTriggered, this);
        });
    }

    showEmote = (emoteKey) => {

        let emoteX = this.carContainer.width - this.common.gameScale;
        let emoteY = -21 * this.common.gameScale;
        if(this.carKey === 'convertible-orange') {
            emoteY = -40 * this.common.gameScale;
            emoteX = this.carContainer.width - 2 * this.common.gameScale;
        }


        const emoteIconConfig = {
            x: emoteX,
            y: emoteY,
            originX: 0.5,
            originY: 1,
            texture: 'emotes',
            scale: this.common.gameScale,
        }
        const enterTween = {
            scale: this.common.gameScale,
            ease: 'Linear',
            duration: 100,
            yoyo: false,
            repeat: 0,
        }
        const midTween = {
            scale: 1.5 * this.common.gameScale,
            ease: 'Linear',
            duration: 250,
            yoyo: true,
            repeat: 1,
        }
        const exitTween = {
            scale: 0,
            alpha: 0,
            ease: 'Linear',
            duration: 150,
            repeat: 0,
        }
        let emote = this.add.sprite(emoteIconConfig.x, emoteIconConfig.y, emoteIconConfig.texture, emoteKey)
                .setOrigin(emoteIconConfig.originX, emoteIconConfig.originY)
        this.carContainer.add(emote);

        this.tweens.chain({
            targets: emote,
            tweens: [
                    enterTween,
                    midTween,
                    exitTween,
            ],
            onComplete: () => {
                emote.destroy()
            }
        })


    }
}

export default Car;